import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';

/**
 * Displays a simple, standalone table of team member entries (represented here as invoice-like objects) using the TableModule. The component provides internal demo data via the teamMembers array and is intended as a presentational UI piece for listing entries.
 * Purpose: render a list/table of items (name, date, plan, amount) and serve as a reusable display component within the application.
 * Inputs/Outputs: This component does not accept inputs or emit outputs; all data is initialized internally. For real usage, inputs and outputs can be added to accept remote data or emit selection events.
 * Key methods: constructor() only; there are no additional public methods. Data is populated via the teamMembers property initializer.
 * Lifecycle hooks: No Angular lifecycle hooks (e.g., OnInit, OnDestroy) are implemented. If asynchronous data loading or cleanup is required, implement the appropriate lifecycle interfaces.
 * @component
 * @selector app-team-members
 * @example
 *   <app-team-members></app-team-members>
 * @input none - This component does not declare any @Input() properties; teamMembers is an internal property.
 * @output none - This component does not emit any @Output() events.
 */
@Component({
  selector: 'app-team-members',
  standalone: true,
  imports: [CommonModule, MatTableModule],
  templateUrl: './team-members.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./team-members.component.scss'],
})
export class TeamMembersComponent {
  displayedColumns: string[] = ['name', 'date', 'plan', 'amount', 'actions'];
  dataSource = new MatTableDataSource<any>();

  teamMembers = [
    {
      name: 'Invoice #001',
      date: 'January 7, 2025',
      plan: 'Way 360 Car Wash',
      amount: '$100',
    },
    {
      name: 'Invoice #002',
      date: 'January 7, 2025',
      plan: 'Way 360 Car Wash',
      amount: '$100',
    },
    {
      name: 'Invoice #003',
      date: 'January 7, 2025',
      plan: 'Way 360 Car Wash',
      amount: '$100',
    },
  ];

  constructor() {
    this.dataSource.data = this.teamMembers;
  }
}
